<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    initializeValue: {
      type: [String, Number],
      default: '',
    },
    // TODO: set default to false and update at all places
    showSelectAsOption: {
      type: String,
      default: 'YES',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    disabledItem: {
      type: Function,
      default: () => { return false }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        this.selectedOption = newValue
      },
    },
  },
  mounted() {
    this.selectedOption = this.value
  },
}
</script>

<template>
  <div>
    <select
      v-model="selectedOption"
      :class="$style.selectbg"
      class="form-control w-100 mb-1"
      v-bind="$attrs"
      :disabled="isDisabled"
      v-on="$listeners"
      @change="$emit('update', $event.target.value)"
    >
      <option v-if="showSelectAsOption === 'YES'" :value="initializeValue"
        >Select</option
      >
      <option
        v-for="option in options"
        :key="option.id"
        :value="option.value"
        :disabled="disabledItem(option)"
        >{{ option.text }}</option
      >
    </select>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.selectbg {
  background-color: $color-content-bg;
  border: $input-border;
}
</style>
